// extracted by mini-css-extract-plugin
module.exports = {"capsuleSummary":"CapsuleSummary_capsuleSummary__3Cdnz"};